export default __webpack_public_path__ + "static/media/slide10.5e45f5d0.png";